import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const SalesOrderList = lazy(() => import('./pages/orders/SalesOrderList'));
const SalesOrderCreate = lazy(() => import('./pages/orders/SalesOrderCreate'));
const SalesOrderWorksheet = lazy(() => import('./pages/orders/SalesOrderWorksheet'));

const QuotationList = lazy(() => import('./pages/quotations/QuotationList'));
const QuotationCreate = lazy(() => import('./pages/quotations/QuotationCreate'));
const QuotationWorksheet = lazy(() => import('./pages/quotations/QuotationWorksheet'));

const SalesReturnList = lazy(() => import('./pages/returns/SalesReturnList'));
const SalesReportHub = lazy(() => import('./pages/reports/SalesReportHub'));

const salesRoutes: RouteObject[] = [
  { index: true, element: <SalesOrderList /> },

  // Sales Orders
  { path: 'orders', element: <SalesOrderList /> },
  { path: 'orders/create', element: <SalesOrderCreate /> },
  { path: 'orders/:id/worksheet', element: <SalesOrderWorksheet /> },
  // /orders/:id reuses the Worksheet — it already renders read-only for
  // completed/cancelled orders and editable for drafts, so a separate view
  // page would just duplicate that status-conditional logic.
  { path: 'orders/:id', element: <SalesOrderWorksheet /> },

  // Direct Quotations
  { path: 'quotations', element: <QuotationList /> },
  { path: 'quotations/create', element: <QuotationCreate /> },
  { path: 'quotations/:id/worksheet', element: <QuotationWorksheet /> },
  { path: 'quotations/:id', element: <QuotationWorksheet /> },

  // Stubs (out of v1 scope)
  { path: 'returns', element: <SalesReturnList /> },
  { path: 'reports', element: <SalesReportHub /> },
];

export default salesRoutes;
